"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAmount = void 0;
var vue_1 = require("vue");
var Button_1 = require("../components/common/Button");
var TranslateMixin_1 = require("./TranslateMixin");
exports.SelectAmount = vue_1.default.component('select-amount', {
    components: {
        'Button': Button_1.Button,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            amount: this.playerinput.maxByDefault ? String(this.playerinput.max) : String(this.playerinput.min),
        };
    },
    methods: {
        saveData: function () {
            this.onsave([[String(parseInt(this.amount))]]);
        },
        setMaxValue: function () {
            this.amount = String(this.playerinput.max);
        },
    },
    template: "\n    <div>\n        <div v-if=\"showtitle === true\">{{ $t(playerinput.title) }}</div>\n        <div class=\"flex\">\n            <input type=\"number\" class=\"nes-input\" value=\"playerinput.min\" :min=\"playerinput.min\" :max=\"playerinput.max\" v-model=\"amount\" />\n            <Button size=\"big\" type=\"max\" :onClick=\"setMaxValue\" title=\"MAX\" />\n            <Button v-if=\"showsave === true\" size=\"big\" :onClick=\"saveData\" :title=\"playerinput.buttonLabel\" />\n        </div>\n    </div>",
});
//# sourceMappingURL=SelectAmount.js.map